import React from "react";
import VerticalTabs from "../../common/VerticalTabs";
import SettingsPage from "./SettingsPage";

const tabs = [
  { id: "my-profile", label: "My Profile", component: SettingsPage },
  { id: "edit-profile", label: "Edit Profile", component: SettingsPage },
  { id: "settings-page", label: "Settings", component: SettingsPage },
];

const Index: React.FC = () => {
  return <VerticalTabs tabs={tabs} title="Settings" />;
};

export default Index;
